<template functional>
  <span
    class="paa-badge"
    :class="[`paa-badge--${(props.badge && props.badge.tone) || 'grey'}`, data.staticClass, data.class]"
    :title="props.title || null"
  >{{ (props.badge && props.badge.label) || '' }}</span>
</template>

<script>
/** Design badge (kit.css .badge): `badge` = { label, tone: suc | warn | dan | info | grey } from the API. */
export default {
  name: 'PopAuthorityAdminBadge',
  props: {
    badge: { type: Object, default: null },
    title: { type: String, default: '' },
  },
}
</script>
